import { render, staticRenderFns } from "./reportheader.vue?vue&type=template&id=191dbe99&scoped=true&"
import script from "./reportheader.vue?vue&type=script&lang=js&"
export * from "./reportheader.vue?vue&type=script&lang=js&"
import style0 from "./reportheader.vue?vue&type=style&index=0&id=191dbe99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191dbe99",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('191dbe99')) {
      api.createRecord('191dbe99', component.options)
    } else {
      api.reload('191dbe99', component.options)
    }
    module.hot.accept("./reportheader.vue?vue&type=template&id=191dbe99&scoped=true&", function () {
      api.rerender('191dbe99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/physical/reportheader.vue"
export default component.exports